/**
 * Mobile Filter Handler for Preset Engagement Rings
 * Handles mobile filter drawer interactions and filter updates
 */

document.addEventListener('DOMContentLoaded', function() {
  // Initialize mobile filter functionality
  initMobileFilter();
  
  // Initialize mobile price sort select (outside mobile filter drawer)
  initMobilePriceSort();
});

function initMobileFilter() {
  // Handle mobile filter button click
  const mobileFilterBtn = document.querySelector('.facet-btn');
  const mobileFilterDrawer = document.querySelector('.mobile-filter-drawer');
  const filterCloseBtn = document.querySelector('.filter-close-btn');
  
  if (mobileFilterBtn && mobileFilterDrawer) {
    mobileFilterBtn.addEventListener('click', function() {
      openMobileFilter();
    });
  }
  
  if (filterCloseBtn && mobileFilterDrawer) {
    filterCloseBtn.addEventListener('click', function() {
      closeMobileFilter();
    });
  }
  
        // Handle filter option clicks
        const filterOptions = document.querySelectorAll('.mobile-filter-content .filter-option');
        filterOptions.forEach(option => {
          option.addEventListener('click', function() {
            handleFilterOptionClick(this);
          });
        });
  
  // Close drawer when clicking outside
  if (mobileFilterDrawer) {
    mobileFilterDrawer.addEventListener('click', function(e) {
      if (e.target === mobileFilterDrawer) {
        closeMobileFilter();
      }
    });
  }
  initActiveStatesFromURL();
  
  // Handle View Results button click using event delegation
document.addEventListener('click', function(e) {
  // Check if click is on View Results button or its children
  const target = e.target.closest('#mobile-view-results-btn');
  if (target) {
    e.preventDefault();
    e.stopPropagation();
      
      // Don't do anything if button is in loading state
      if (target.classList.contains('loading')) {
        return;
      }
      
      // Trigger the filter close button click
      const filterCloseBtn = document.querySelector('.filter-close-btn');
      if (filterCloseBtn) {
        filterCloseBtn.click();
      } else {
        // Fallback to direct close
        closeMobileFilter();
      }
    }
  });
}

function openMobileFilter() {
  const mobileFilterDrawer = document.querySelector('.mobile-filter-drawer');
  if (mobileFilterDrawer) {
    // Prevent body scroll when drawer is open
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    
    mobileFilterDrawer.style.display = 'block';
    
    // Add animation class - use 'open' to match CSS
    setTimeout(() => {
      mobileFilterDrawer.classList.add('open');
      try { renderMobileWeddingStyles(); } catch (e) {}
    }, 10);
  }
}

function closeMobileFilter() {
  const mobileFilterDrawer = document.querySelector('.mobile-filter-drawer');
  if (mobileFilterDrawer) {
    // Remove 'open' class and add 'closing' class to match CSS
    mobileFilterDrawer.classList.remove('open');
    mobileFilterDrawer.classList.add('closing');
    
    // Restore body overflow immediately to fix scroll issue
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.documentElement.style.overflow = '';
    
    setTimeout(() => {
      mobileFilterDrawer.style.display = 'none';
      mobileFilterDrawer.classList.remove('closing');
    }, 400); // Match transition duration
  }
}

function updateFilterCurrentValue(filterType, filterValue, option) {
  const filterGroup = option.closest('.filter-group');
  const currentValueElement = filterGroup.querySelector('.current-value-text');
  
  if (currentValueElement) {
    if (filterType === 'shape') {
      // Capitalize first letter for shape
      const displayValue = filterValue.charAt(0).toUpperCase() + filterValue.slice(1);
      currentValueElement.textContent = displayValue;
    } else if (filterType === 'carat') {
      // Display carat value as is
      currentValueElement.textContent = filterValue;
    } else if (filterType === 'material') {
      // Get material display value
      const displayValue = getMaterialValue(filterValue);
      currentValueElement.textContent = displayValue;
    } else if (filterType === 'style') {
      const displayValue = option.querySelector('.option-text')?.innerText || filterValue;
      currentValueElement.textContent = displayValue;
    } else if (filterType === 'price') {
      // Get price display value
      const displayValue = getPriceValue(filterValue);
      currentValueElement.textContent = displayValue;
    }
  }
}

function handleFilterOptionClick(option) {
  // Prevent default behavior to avoid page reload
  event.preventDefault();
  event.stopPropagation();
  
  // Remove active class from siblings
  const siblings = option.parentNode.querySelectorAll('.filter-option');
  siblings.forEach(sibling => sibling.classList.remove('active'));
  
  // Add active class to clicked option
  option.classList.add('active');
  
  // Get filter type and value
  const filterType = option.closest('.filter-group').dataset.filterType;
  const filterValue = option.dataset.value;

  const isWeddingBands = !!document.querySelector('.wedding-band-filter') || (window.location.pathname || '').indexOf('/collections/wedding-bands') !== -1;
  
  // Update current value text in filter title
  updateFilterCurrentValue(filterType, filterValue, option);
  
  // Show loading state on View Results button
  showViewResultsLoading();
  
  if (isWeddingBands) {
    if (filterType === 'gender' && typeof window.weddingBandSetGender === 'function') {
      window.weddingBandSetGender(filterValue);
      return;
    }
    if (filterType === 'style' && typeof window.weddingBandSetStyle === 'function') {
      window.weddingBandSetStyle(filterValue);
      return;
    }
  }

  if (filterType === 'material' && filterValue) {
    updateMobileFilter(filterType, filterValue);
    if (typeof window.selectMaterialPreset === 'function') {
      const inputId = `Filter-preset-material-${getMaterialIndex(filterValue)}`;
      window.selectMaterialPreset(inputId);
    } else if (window.location.pathname.includes('eternity-rings') && typeof window.fetchEternityRings === 'function') {
      setTimeout(() => {
        const shapeSlug = new URLSearchParams(window.location.search).get('shape') || 'round';
        const handle = `eternity-${shapeSlug}-${filterValue}`;
        window.fetchEternityRings(handle);
      }, 50);
    }
  } else if (filterType === 'shape' && filterValue) {
    updateMobileFilter(filterType, filterValue);
    const capitalizedValue = filterValue.charAt(0).toUpperCase() + filterValue.slice(1);
    if (window.location.pathname.includes('eternity-rings')) {
      if (typeof window.selectStoneShapePreset === 'function') {
        const radios = document.querySelectorAll('input[name="filter.p.m.custom.shape_eternity"]');
        const targetRadio = Array.from(radios).find((r) => String(r.value).toLowerCase() === filterValue.toLowerCase());
        if (targetRadio) {
          window.selectStoneShapePreset(targetRadio);
        } else if (typeof window.fetchEternityRings === 'function') {
          setTimeout(() => {
            const materialSlug = new URLSearchParams(window.location.search).get('material')?.toLowerCase().replace(/\s+/g, '-') || '14k-yellow-gold';
            const handle = `eternity-${filterValue}-${materialSlug}`;
            window.fetchEternityRings(handle);
          }, 50);
        }
      } else if (typeof window.fetchEternityRings === 'function') {
        setTimeout(() => {
          const materialSlug = new URLSearchParams(window.location.search).get('material')?.toLowerCase().replace(/\s+/g, '-') || '14k-yellow-gold';
          const handle = `eternity-${filterValue}-${materialSlug}`;
          window.fetchEternityRings(handle);
        }, 50);
      }
    } else if (typeof window.filterByShape === 'function') {
      setTimeout(() => {
        window.filterByShape(capitalizedValue);
      }, 50);
    }
  } else if (filterType === 'carat' && filterValue) {
    // Call filterByCarat directly for carat filters
    if (typeof window.filterByCarat === 'function') {
      window.filterByCarat(filterValue);
    } else {
      // Fallback to URL update
      updateMobileFilter(filterType, filterValue);
    }
  } else if (filterType === 'price' && filterValue) {
    // Handle price sort filters
    if (typeof window.filterByPrice === 'function') {
      window.filterByPrice(filterValue);
    } else {
      // Fallback to URL update for price sorting
      updateMobileFilter(filterType, filterValue);
    }
  } else if (filterType === 'style' && filterValue) {
    const url = new URL(window.location);
    url.searchParams.set('style', filterValue);
    const keep = ['style', 'material'];
    Array.from(url.searchParams.keys()).forEach((k) => {
      if (keep.indexOf(k) === -1) {
        url.searchParams.delete(k);
      }
    });
    window.history.pushState({}, '', url.toString());
    document.documentElement.setAttribute('data-style-mode', 'true');
    if (typeof window.applyFilters === 'function') {
      window.applyFilters();
    } else {
      window.dispatchEvent(new CustomEvent('filterChanged', {
        detail: { type: 'style', value: filterValue }
      }));
    }
  } else if (filterType && filterValue) {
    // Update URL with filter parameters for other filters
    updateMobileFilter(filterType, filterValue);
  }
}

function renderMobileWeddingStyles() {
  const isWeddingBands = !!document.querySelector('.wedding-band-filter') || (window.location.pathname || '').indexOf('/collections/wedding-bands') !== -1;
  if (!isWeddingBands) return;
  const container = document.getElementById('mobile-style-filter-options');
  if (!container || !window.weddingBandStyles) return;
  const gender = typeof window.weddingBandGetGender === 'function' ? window.weddingBandGetGender() : 'her';
  const styles = gender === 'him' ? window.weddingBandStyles.him : window.weddingBandStyles.her;
  const urlStyle = new URLSearchParams(window.location.search).get('style');
  let selectedSlug = urlStyle || (typeof window.weddingBandGetStyle === 'function' ? window.weddingBandGetStyle() : null);
  selectedSlug = selectedSlug ? selectedSlug.toLowerCase() : null;
  if (!styles.some((s) => s.slug === selectedSlug)) {
    selectedSlug = styles.length ? styles[0].slug : null;
  }
  container.innerHTML = styles.map((s) => `
    <button class="filter-option${s.slug===selectedSlug?' active':''}" data-value="${s.slug}">
      <div class="option-icon">${s.icon}</div>
      <span class="option-text">${s.name}</span>
    </button>
  `).join('');
  const currentText = document.querySelector('.filter-group[data-filter-type="style"] .current-value-text');
  if (currentText) {
    const m = styles.find((s) => s.slug === selectedSlug) || styles[0];
    currentText.textContent = m ? m.name : '';
  }
}



function getMaterialValue(dataValue) {
  // Convert data-value to material display value
  const materialMap = {
    '14k-white-gold': '14K White Gold',
    '14k-yellow-gold': '14K Yellow Gold', 
    '14k-rose-gold': '14K Rose Gold',
    '18k-white-gold': '18K White Gold',
    '18k-yellow-gold': '18K Yellow Gold',
    '18k-rose-gold': '18K Rose Gold',
    'platinum': 'Platinum'
  };
  return materialMap[dataValue] || dataValue;
}

function getMaterialIndex(dataValue) {
  // Get the index for selectMaterialPreset function
  const materialIndexMap = {
    '14k-white-gold': 1,
    '14k-yellow-gold': 2,
    '14k-rose-gold': 3, 
    '18k-white-gold': 4,
    '18k-yellow-gold': 5,
    '18k-rose-gold': 6,
    'platinum': 7
  };
  return materialIndexMap[dataValue] || 1;
}

// Shape Filter Functions
function selectShapePreset(inputId) {
  const input = document.getElementById(inputId);
  if (input && !input.disabled) {
    const option = input.closest('.filter-shape-preset-option');
    const text = option.querySelector('span')?.innerText || 'Shape';
    const icon = option.querySelector('svg')?.outerHTML || '';

    // Update text
    const textElement = document.getElementById('selectedShapePresetText');
    if (textElement) {
      textElement.innerText = input.value;
    }

    // Replace icon
    const iconHolder = document.getElementById('selectedShapePresetIcon');
    if (iconHolder) {
      iconHolder.innerHTML = icon;
    }

    const trigger = document.querySelector('.filter-shape-preset-trigger');
    if (trigger) {
      trigger.classList.add('has-value');
    }

    // Reset & select radio
    document.querySelectorAll('.filter-shape-preset-option').forEach((opt) => opt.classList.remove('selected'));
    document.querySelectorAll(`input[name="${input.name}"]`).forEach((radio) => (radio.checked = false));

    input.checked = true;
    option.classList.add('selected');

    // Call filterByShape function for preset engagement rings
    if (typeof window.filterByShape === 'function') {
      window.filterByShape(input.value);
    }

    // Close dropdown
    const dropdown = document.getElementById('shapePresetDropdown');
    if (dropdown) {
      dropdown.classList.remove('show');
    }
    if (trigger) {
      trigger.classList.remove('active');
    }
  }
}

function getShapeValue(dataValue) {
  // Convert data-value to shape display value
  const shapeMap = {
    'round': 'Round',
    'princess': 'Princess',
    'emerald': 'Emerald',
    'asscher': 'Asscher',
    'marquise': 'Marquise',
    'oval': 'Oval',
    'pear': 'Pear',
    'heart': 'Heart',
    'cushion': 'Cushion',
    'radiant': 'Radiant'
  };
  return shapeMap[dataValue] || dataValue;
}


// Carat Weight Filter Functions

function getCaratValue(dataValue) {
  // Convert data-value to carat display value
  const caratMap = {
    '1.0': '1.0 Carat',
    '1.5': '1.5 Carat',
    '2.0': '2.0 Carat',
    '2.5': '2.5 Carat',
    '3.0': '3.0 Carat',
    '3.5': '3.5 Carat',
    '4.0': '4.0 Carat',
    '4.5': '4.5 Carat',
    '5.0': '5.0 Carat'
  };
  return caratMap[dataValue] || dataValue;
}

function getPriceValue(dataValue) {
  // Convert data-value to price display value
  const priceMap = {
    'price-low-high': 'Price (low-to-high)',
    'price-high-low': 'Price (high-to-low)'
  };
  return priceMap[dataValue] || dataValue;
}



function updateMobileFilter(type, value) {
  const url = new URL(window.location);
  
  // Handle different filter types
  if (type === 'material') {
    url.searchParams.set('material', value);
  } else if (type === 'shape') {
    url.searchParams.set('shape', value);
  } else if (type === 'carat') {
    url.searchParams.set('carat', value);
  } else if (type === 'price') {
    // Handle price sorting
    if (value === 'price-low-high') {
      url.searchParams.set('sort_by', 'price');
      url.searchParams.delete('reverse');
    } else if (value === 'price-high-low') {
      url.searchParams.set('sort_by', 'price');
      url.searchParams.set('reverse', 'true');
    }
  } else {
    url.searchParams.set(type, value);
  }
  
  // Update URL without reloading page using History API
  window.history.pushState({}, '', url.toString());
  
  // Trigger custom event to notify other components about filter change
  window.dispatchEvent(new CustomEvent('filterChanged', {
    detail: { type: type, value: value }
  }));
}

// Material Preset Functions (from filter-material-preset.liquid)
function toggleMaterialPresetDropdown() {
  const dropdown = document.getElementById('materialPresetDropdown');
  const trigger = document.querySelector('.filter-material-preset-trigger');

  if (dropdown && trigger) {
    if (dropdown.classList.contains('show')) {
      dropdown.classList.remove('show');
      trigger.classList.remove('active');
    } else {
      dropdown.classList.add('show');
      trigger.classList.add('active');
    }
  }
}



function clearMaterialPreset(event) {
  if (event) {
    event.preventDefault();
  }

  const trigger = document.querySelector('.filter-material-preset-trigger');
  if (trigger) {
    // Reset text + icon
    const textElement = document.getElementById('selectedMaterialPresetText');
    if (textElement) {
      textElement.innerText = 'Metal';
    }
    
    const iconHolder = document.getElementById('selectedMaterialPresetIcon');
    if (iconHolder) {
      iconHolder.innerHTML = '';
    }
    
    trigger.classList.remove('has-value');

    // Uncheck radios
    const radios = document.querySelectorAll('input[name="filter.p.m.custom.material"]');
    radios.forEach((radio) => {
      radio.checked = false;
    });

    // Call filterByMaterial with empty value
    if (typeof window.filterByMaterial === 'function') {
      window.filterByMaterial('');
    }
  }
}

// Close dropdown when clicking outside
document.addEventListener('click', function (event) {
  const dropdown = document.getElementById('materialPresetDropdown');
  const trigger = document.querySelector('.filter-material-preset-trigger');

  if (dropdown && trigger && !event.target.closest('.filter-material-preset-select')) {
    dropdown.classList.remove('show');
    trigger.classList.remove('active');
  }
});

// Delegated handler for dynamically rendered filter options in drawer
document.addEventListener('click', function(e) {
  const option = e.target.closest('.mobile-filter-content .filter-option');
  if (option) {
    handleFilterOptionClick(option);
  }
});

// Outside gender toggle (wedding-bands)
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.mobile-gender-toggle .band-type-btn, .mobile-gender-toggle .toggle-btn');
  if (!btn) return;
  const gender = btn.dataset.gender;
  const wrap = btn.closest('.mobile-gender-toggle');
  wrap.querySelectorAll('.band-type-btn, .toggle-btn').forEach(b => b.classList.remove('active'));
  btn.classList.add('active');
  const indicator = wrap.querySelector('.band-type-indicator');
  if (indicator) {
    indicator.classList[gender === 'him' ? 'add' : 'remove']('active-him');
  }
  if (typeof window.weddingBandSetGender === 'function') {
    window.weddingBandSetGender(gender);
  }
  try { renderMobileWeddingStyles(); } catch (e) {}
});

// View Results Button Loading State
function showViewResultsLoading() {
  const viewResultsBtn = document.getElementById('mobile-view-results-btn');
  if (viewResultsBtn) {
    viewResultsBtn.classList.add('loading');
    viewResultsBtn.disabled = true;
  }
}

function hideViewResultsLoading() {
  const viewResultsBtn = document.getElementById('mobile-view-results-btn');
  if (viewResultsBtn) {
    viewResultsBtn.classList.remove('loading');
    viewResultsBtn.disabled = false;
  }
}

// Export functions for external use
window.MobileFilter = {
  open: openMobileFilter,
  close: closeMobileFilter,
  update: updateMobileFilter,
  showLoading: showViewResultsLoading,
  hideLoading: hideViewResultsLoading
};

// Export material preset functions globally
window.toggleMaterialPresetDropdown = toggleMaterialPresetDropdown;
window.clearMaterialPreset = clearMaterialPreset;

// Export shape preset functions globally
window.selectShapePreset = selectShapePreset;

// Mobile Price Sort Functions
function initMobilePriceSort() {
  const mobilePriceSortSelect = document.getElementById('priceSortSelect_mobile');
  
  if (mobilePriceSortSelect) {
    // Set initial selected value based on URL parameters
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get('sort_by');
    const reverse = urlParams.get('reverse');
    
    if (sortBy === 'price' && reverse === 'true') {
      mobilePriceSortSelect.value = 'price-high-low';
    } else {
      mobilePriceSortSelect.value = 'price-low-high';
    }
    
    mobilePriceSortSelect.addEventListener('change', function() {
      const sortValue = this.value;
      
      // Check if we're on the engagement rings page and have the filter function available
      if (typeof window.filterByPrice === 'function') {
        // Use the GraphQL filtering system
        console.log('Calling filterByPrice with value:', sortValue);
        window.filterByPrice(sortValue);
      } else if ((window.location.pathname || '').indexOf('/collections/wedding-bands') !== -1 && typeof window.weddingBandsSetPriceSort === 'function') {
        // Use wedding-bands sorting without page reload
        console.log('Calling weddingBandsSetPriceSort with value:', sortValue);
        window.weddingBandsSetPriceSort(sortValue);
      } else if ((window.location.pathname || '').indexOf('/collections/eternity-rings') !== -1 && typeof window.eternityRingsSetPriceSort === 'function') {
        // Use eternity-rings sorting without page reload
        console.log('Calling eternityRingsSetPriceSort with value:', sortValue);
        window.eternityRingsSetPriceSort(sortValue);
      } else if ((window.location.pathname || '').indexOf('/collections/stackable-rings') !== -1 && typeof window.stackableRingsSetPriceSort === 'function') {
        console.log('Calling stackableRingsSetPriceSort with value:', sortValue);
        window.stackableRingsSetPriceSort(sortValue);
      } else if ((window.location.pathname || '').indexOf('/collections/statement-rings') !== -1 && typeof window.statementRingsSetPriceSort === 'function') {
        console.log('Calling statementRingsSetPriceSort with value:', sortValue);
        window.statementRingsSetPriceSort(sortValue);
      } else {
        // Fallback to URL-based sorting for other pages
        console.log('Using URL-based sorting for value:', sortValue);
        const currentUrl = new URL(window.location);
        currentUrl.searchParams.delete('sort_by');
        currentUrl.searchParams.delete('reverse');
        if (sortValue === 'price-low-high') {
          currentUrl.searchParams.set('sort_by', 'price');
        } else if (sortValue === 'price-high-low') {
          currentUrl.searchParams.set('sort_by', 'price');
          currentUrl.searchParams.set('reverse', 'true');
        }
        window.location.href = currentUrl.toString();
      }
    });
  }
}

function initActiveStatesFromURL() {
  const params = new URLSearchParams(window.location.search);
  const rawShape = params.get('shape');
  const rawMaterial = params.get('material');
  const rawStyle = params.get('style');

  const shapeSlug = rawShape ? String(rawShape).toLowerCase() : null;
  const materialSlug = rawMaterial
    ? String(rawMaterial).toLowerCase().replace(/\+/g, ' ').replace(/\s+/g, '-')
    : null;

  if (rawStyle) {
    document.documentElement.setAttribute('data-style-mode', 'true');
    const styleGroup = document.querySelector('.mobile-filter-content .filter-group[data-filter-type="style"]');
    if (styleGroup) {
      const all = styleGroup.querySelectorAll('.filter-option');
      all.forEach(b => b.classList.remove('active'));
      const slug = String(rawStyle).toLowerCase();
      const btn = styleGroup.querySelector(`.filter-option[data-value="${slug}"]`);
      if (btn) {
        btn.classList.add('active');
        const currentEl = styleGroup.querySelector('.current-value-text');
        const labelEl = btn.querySelector('.option-text');
        if (currentEl) currentEl.textContent = labelEl ? labelEl.textContent : slug;
      }
    }
  }

  const shapeGroup = document.querySelector('.mobile-filter-content .filter-group[data-filter-type="shape"]');
  if (shapeGroup) {
    const all = shapeGroup.querySelectorAll('.filter-option');
    all.forEach(b => b.classList.remove('active'));
    const slug = shapeSlug || (all[0] ? all[0].dataset.value : null);
    const btn = slug ? shapeGroup.querySelector(`.filter-option[data-value="${slug}"]`) : null;
    if (btn) btn.classList.add('active');
    const currentEl = shapeGroup.querySelector('.current-value-text');
    if (currentEl && slug) currentEl.textContent = slug.charAt(0).toUpperCase() + slug.slice(1);
  }

  const materialGroup = document.querySelector('.mobile-filter-content .filter-group[data-filter-type="material"]');
  if (materialGroup) {
    const all = materialGroup.querySelectorAll('.filter-option');
    all.forEach(b => b.classList.remove('active'));
    const slug = materialSlug || (all[0] ? all[0].dataset.value : null);
    const btn = slug ? materialGroup.querySelector(`.filter-option[data-value="${slug}"]`) : null;
    if (btn) btn.classList.add('active');
    const currentEl = materialGroup.querySelector('.current-value-text');
    if (currentEl && slug) currentEl.textContent = getMaterialValue(slug);
  }
}
